import { Tooltip } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';

interface IInlineStyles {
    [key: string]: string
}

type IconColor = 'inherit'
    | 'action'
    | 'disabled'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'

type IconSize = 'inherit'
    | 'large'
    | 'medium'
    | 'small'

export function TooltipIcon(props: Readonly<{
    IconComponent: typeof SvgIcon,
    tooltipTitle: string,
    iconInlineStyles?: IInlineStyles,
    iconColor?: IconColor
    iconSize?: IconSize
}>) {
    const {
        IconComponent,
        tooltipTitle,
        iconInlineStyles,
        iconColor,
        iconSize
    } = props;

    return (
        <Tooltip title={tooltipTitle}>
            <IconComponent
                color={iconColor}
                sx={iconInlineStyles}
                fontSize={iconSize}
            />
        </Tooltip>
    );
}
